<template>
    <div class="section pt-1">
        <div class="wallet-card">
            <div class="balance">
                <div class="left">
                    <span class="title">നീക്കം ചെയ്ത ലിസ്റ്റ് [{{ unit.name }}]</span>
                    <h1 class="total text-primary">{{ member_lists.total }}</h1>
                </div>
            </div>
            <router-link :to="'/org/'+$route.params.sub_level+'/'+$route.params.id+'/relief-new-list'">
                <button type="button" class="btn btn-outline-primary me-1 mal-text btn-lg col-12 mb-2">
                    വിസ്‌ഡം റിലീഫ് 2026 ലിസ്റ്റിലേക്ക്
                    <ion-icon name="chevron-forward-outline" style="font-size: 60px;"></ion-icon>
                </button>
            </router-link>
            <router-link :to="'/org/'+$route.params.sub_level+'/'+$route.params.id+'/relief-old-list'">
                <button type="button" class="btn btn-outline-primary me-1 mal-text btn-lg col-12 mb-2">
                    പഴയ ലിസ്റ്റിലേക്ക്
                    <ion-icon name="chevron-forward-outline" style="font-size: 60px;"></ion-icon>
                </button>
            </router-link>
        </div>
    </div>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-3">
            <h3 class="text-center mt-2 mal-text custom-title">നീക്കം ചെയ്തവരുടെ ലിസ്റ്റ്</h3>
        </div>
    </div>
    <div id="search">
        <form class="search-form">
            <div class="form-group searchbox">
                <input type="text" class="form-control" placeholder="ഇവിടെ സെർച്ച് ചെയ്യുക..." v-model="search_qry"
                    @input="getMembersList(1,$event.target.value)">
                <i class="input-icon">
                    <ion-icon name="search-outline"></ion-icon>
                </i>
            </div>
        </form>
    </div>
    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="listed-detail mt-0">
        <h4 class="text-center mt-0 mal-text" v-if="!loading_list && member_lists.total <= 0">
            നീക്കം ചെയ്ത രേഖകൾ ഒന്നുമില്ല
        </h4>
    </div>

    <ul class="listview image-listview inset text mt-2" v-if="!loading_list && member_lists.total > 0">
        <li v-for="(member_list, index) in member_lists.data" v-bind:key="member_list.id">
            <a href="javascript:void(0)" class="item">
                <span class="sl-no">{{ (member_lists.from + index) }}</span>
                <div class="avatar-section">
                    <a href="#">
                        <img src="assets/img/sample/avatar/avatar1.png" alt="avatar" class="image">
                    </a>
                </div>
                <div class="in">
                    <div class="min-width-50">
                        <b>{{ member_list.family_head_name }}</b>
                        <footer class="text-primary">{{ member_list.family_contact }}</footer>
                        <small class="text-muted" v-if="member_list.deleted_at">
                            നീക്കം ചെയ്ത തീയതി: {{ formatDate(member_list.deleted_at) }}
                        </small>
                    </div>
                    <div class="card-button dropdown">
                        <a :href="'tel:' + member_list.family_contact" class="btn btn-link btn-icon">
                            <ion-icon name="call-outline"></ion-icon>
                        </a>
                    </div>
                </div>
            </a>
        </li>
    </ul>
    <div class="section mt-2" v-if="!loading_list">
        <vue-awesome-paginate v-if="member_lists.total > 0" :total-items="member_lists.total"
            :items-per-page="member_lists.per_page" :max-pages-shown="3" v-model="member_lists.current_page"
            :on-click="getMembersList" :show-ending-buttons="true" :show-breakpoint-buttons="false" />
    </div>
</template>

<script>
// Register route: path: '/org/:sub_level/:id/relief-deleted-list', component: ReliefDeletedList
import UserService from "../../services/user.service";
import $ from 'jquery';

export default {
    name: 'ReliefDeletedList',
    props: {
        unit_id: null
    },
    data() {
        return {
            loading_list: false,
            user_level: "",
            member_lists: { total: 0, per_page: 20, current_page: 1, from: 0, data: [] },
            unit: {},
            permissions: [],
            search_qry: ''
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = parseInt(this.$route.params.sub_level);
            this.getMembersList(1);
            this.$root.updateParent('നീക്കം ചെയ്ത ലിസ്റ്റ്');
        }
        window.onpopstate = function () {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };
    },
    methods: {
        formatDate(val) {
            if (!val) return '';
            const d = new Date(val);
            return d.toLocaleDateString('ml-IN', { day: 'numeric', month: 'short', year: 'numeric' });
        },
        getMembersList(page = 1, search_qry = null) {
            this.loading_list = true;
            let data = {
                user_level: this.user_level,
                unit_id: parseInt(this.$route.params.id),
                search_qry: search_qry ? search_qry : ''
            };
            UserService.authPostRequest(`get-relief-families?type=deleted&page=${page}`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.permissions = response.data.data.permissions || {};
                        this.member_lists = response.data.data.list;
                        this.unit = response.data.data.unit;
                        this.loading_list = false;
                        this.$root.updateParent('നീക്കം ചെയ്ത ലിസ്റ്റ്');
                    } else {
                        this.loading_list = false;
                    }
                },
                (error) => {
                    this.loading_list = false;
                    this.message =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
    },
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.listview {
    margin-bottom: 0px;
}

.min-width-50 {
    min-width: 60% !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.image-listview.text>li:after {
    left: 0px;
    background-color: #1a418c;
}

.wallet-card {
    padding-bottom: 0px !important;
}

.wallet-card .balance .title {
    color: #27173E;
    font-weight: 500;
    font-size: 16px;
    display: block;
    margin-bottom: 8px;
}
</style>
